import React, { useState, useEffect } from 'react'
import {
  RaisedClaimChatBox,
  ChatHeader,
  ChatboxBody,
  TextAreaWrapper,
} from "../../CommonPages/ClaimRaise/OrderTabs/trackDetailTypeOneStyled";
import ChatCloseIcon from 'web/assets/svg/ChatCloseIcon';
import { useHistory } from 'react-router-dom';
import ChatEnterIcon from "web/assets/svg/ChatEnterIcon";
import * as moment from 'moment';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import { useDispatch, useSelector } from 'react-redux';
import { postClaimMessageForAdmin } from 'redux/actions/myClaims';
const ChatboxComponent = ({ toggleFunction, item, userTypeValue }) => {

  const dispatch = useDispatch();
  let history = useHistory()

  const [raiseClaimtoggle, setraiseClaimtoggle] = useState(true)
  const [privacyOptionForBuyer, setPrivacyOptionForBuyer] = useState('public')
  const [chatMessageForBuyer, setChatMessageForBuyer] = useState("")
  const [chatMessageListForSeller, setchatMessageListForSeller] = useState([])
  const [privacyOptionForSeller, setPrivacyOptionForSeller] = useState('public')
  const [chatMessageForSeller, setChatMessageForSeller] = useState("")
  const [userType, setuserType] = useState("")

  useEffect(() => {
    const intervalCall = setInterval(() => {

      fetchApiForChatMessageForSeller()

    }, 2000);
    return () => clearInterval(intervalCall)
  }, [])

  const fetchApiForChatMessageForSeller = async () => {

    const token = localStorage.getItem('token');
    let userAuth

    if (item.sellerInfo?.locationsId) {
      userAuth = item.sellerInfo.locationsId.toString()
    }
    else {
      userAuth = item.sellerInfo?.locationId
    }

    let data = {
      userAuth: userAuth,
      userType: "SELLER",
      orderId: item.orderId,
      claimId: item.claimId,
      admin: "demo",
      date: new Date(),
      msg: chatMessageForSeller,
      to: privacyOptionForSeller == "public" ? "SELLER" : "ADMIN",
      from: "ADMIN",
      "private": privacyOptionForBuyer == "public" ? false : true
    }

    let response = await dispatch(postClaimMessageForAdmin(data, token));

    if (response && response.status === 'SUCCESS') {

      setchatMessageListForSeller(response?.payload?.msg)

    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      }
    }

  }




  const postMessageForSeller = async () => {

    if (chatMessageForSeller.length) {

      const token = localStorage.getItem('token');
      let userAuth
      if (item.sellerInfo?.locationsId) {
        userAuth = item.sellerInfo.locationsId.toString()
      }
      else {
        userAuth = item.sellerInfo?.locationId
      }

      let data = {
        userAuth: userAuth,
        userType: "SELLER",
        orderId: item.orderId,
        claimId: item.claimId,
        admin: "demo",
        date: new Date(),
        msg: chatMessageForSeller,
        to: privacyOptionForSeller == "public" ? "SELLER" : "ADMIN",
        from: "ADMIN",
        "private": privacyOptionForSeller == "public" ? false : true
      }
      setChatMessageForSeller("")
      let response = await dispatch(postClaimMessageForAdmin(data, token));


      if (response && response.status === 'SUCCESS') {
        setchatMessageListForSeller(response?.payload?.msg)

      } else {
        if (response.statusCode === 401) {
          localStorage.removeItem('token')
          history.push('/sign-in')
          window.location.reload(false);
        }
      }
    }
    setChatMessageForSeller("")
  }

  return (

    <>

      <div style={{ display: 'flex', alignItems: '', padding: '5px' }}>


        <RaisedClaimChatBox style={{ right: "0", marginRight: "20px", marginTop: "10px" }}>


          <ChatHeader style={{ maxHeight: "15%", maxWidth: "", marginRight: "", backgroundColor: "" }}>
            <ChatUserIcon color="#fff" />
            <h6 style={{ marginTop: "-1%", color: "white" }}>
              Chat with Seller
            </h6>
            <ChatCloseIcon
              className="close-icon"
              onClick={() => {
                setraiseClaimtoggle(false)
                setuserType("")
                toggleFunction(item, "SELLER")


              }}

            />
          </ChatHeader>
          <div style={{ height: "200px", overflow: "auto", display: 'flex', flexDirection: 'column-reverse' }}>
            <div>
              <ChatboxBody style={{ backgroundColor: '' }}>
                <div style={{ position: 'sticky', top: '0px', textAlign: 'center', zIndex: '2', margin: '5px' }}>

                </div>

                {chatMessageListForSeller && chatMessageListForSeller.map(data => {
                  return (
                    <>
                      {data.msg.length > 0 &&
                        <div className={data.from == 'ADMIN' ? 'chat-listing-user' : 'chat-listing-admin'}>
                          <ChatUserIcon color={data.from != 'ADMIN' ? "#69BBE0" : "#6d7b69"} />
                          <div style={{ overflow: "hidden" }}>
                            <p class={data.from != 'ADMIN' ? "chat-container" : "chat-container darker"}>{data.msg}</p>
                            <span class={data.from == 'ADMIN' ? "time-right" : "time-left"}>
                              {moment(data.date).format('MMM Do, YYYY, HH:mm')}
                            </span>
                          </div>
                        </div>
                      }
                    </>
                  )
                })}

              </ChatboxBody>
            </div>
          </div>
          {item.claimStatus !== "ADMIN_RESOLVED" &&
            <>
              <TextAreaWrapper>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <input
                      style={{ margin: '6px', appearance: 'auto' }}
                      type="radio"
                      value="private"
                      checked={privacyOptionForSeller === "private"}
                      onChange={e => setPrivacyOptionForSeller(e.target.value)}
                    />
                    Our team only—private to admins
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <input
                      style={{ margin: '6px', appearance: 'auto' }}
                      type="radio"
                      value="public"
                      checked={privacyOptionForSeller === "public"}
                      onChange={e => setPrivacyOptionForSeller(e.target.value)}
                    />
                    Post publicly - Allow buyers/sellers to see
                  </div>
                </div>
              </TextAreaWrapper>
              <TextAreaWrapper>
                <textarea
                  style={{ width: "100%" }}
                  value={chatMessageForSeller}
                  rows="1"
                  placeholder="Please Type Message"
                  onChange={(e) =>
                    setChatMessageForSeller(e.target.value)
                  }
                  onKeyDown={(e) => {

                    if (e.key === "Enter") {
                      postMessageForSeller()

                    }


                  }}
                />
                <ChatEnterIcon
                  style={{ opacity: chatMessageForSeller !== '' ? '1' : '0.5' }}
                  onClick={() => {
                    postMessageForSeller()

                  }
                  }

                />
              </TextAreaWrapper>
            </>
          }
        </RaisedClaimChatBox>

      </div>


    </>




  )
}

export default ChatboxComponent
